import { Issue } from '../../../../setup/types/core';
import { UserInDto } from 'shared/domain/user/types/inDto';
import { AccessLevelModel } from 'shared/domain/issue/mapping/accessLevel/model/types';
import { isManagerOrAdmin } from 'shared/domain/role/isManagerOrAdmin';

export function canEdit(
  userDto: UserInDto,
  userAccesses?: Issue['userAccesses']
): boolean {
  return (
    isManagerOrAdmin(userDto.role) ||
    hasEditInUserAccesses(userDto, userAccesses)
  );
}

function hasEditInUserAccesses(
  userDto: UserInDto,
  userAccesses?: Issue['userAccesses']
): boolean {
  return (
    Array.isArray(userAccesses) &&
    userAccesses.some(
      (access) =>
        access.accessLevel === AccessLevelModel.EDIT &&
        access.accessingUser === userDto._id
    )
  );
}
